import React, { useEffect, useState } from 'react';

export default function Splash({ onDone }) {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFade(true), 1500);
    const t2 = setTimeout(() => onDone(), 2000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'linear-gradient(160deg, #1C2B1E 0%, #2D7A52 100%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      transition: 'opacity 0.5s ease',
      opacity: fade ? 0 : 1,
      pointerEvents: fade ? 'none' : 'all',
    }}>
      {/* BLOBS */}
      <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', background: '#52C289', filter: 'blur(80px)', opacity: 0.2, top: -60, right: -60 }} />
      <div style={{ position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: '#FF7043', filter: 'blur(60px)', opacity: 0.15, bottom: 60, left: -40 }} />

      <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        {/* LOGO */}
        <div style={{
          fontSize: '4rem', marginBottom: 20,
          animation: 'splashBounce 0.6s ease both',
        }}>🧒🏻</div>

        <div style={{
          fontFamily: 'Fredoka One, cursive',
          fontSize: '3rem',
          marginBottom: 8,
          animation: 'splashFadeUp 0.6s ease 0.2s both',
        }}>
          <span style={{ color: '#52C289' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span>
        </div>

        <div style={{
          fontSize: '0.9rem',
          color: 'rgba(255,255,255,0.7)',
          fontFamily: 'Nunito, sans-serif',
          fontWeight: 600,
          animation: 'splashFadeUp 0.6s ease 0.4s both',
        }}>
          Tes copains t'attendent ! 🌿
        </div>

        {/* LOADER */}
        <div style={{
          marginTop: 48,
          display: 'flex', gap: 8, justifyContent: 'center',
          animation: 'splashFadeUp 0.6s ease 0.6s both',
        }}>
          {[0, 1, 2].map(i => (
            <div key={i} style={{
              width: 8, height: 8, borderRadius: '50%',
              background: '#52C289',
              animation: `dotPulse 1s ease ${i * 0.2}s infinite`,
            }} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes splashBounce {
          from { transform: scale(0.5); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes splashFadeUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes dotPulse {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.4); opacity: 1; }
        }
      `}</style>
    </div>
  );
}